export const RAD_WORKFLOW_FIELDS = {
	node_name: {
		id: 'node_name',
		value: '',
		name: 'RAD entity name',
		mandatory: true,
		description: 'The Entity Name of RAD',
		type: 'text',
	},
	node_type: {
		id: 'node_type',
		value: '',
		name: 'Node type',
		mandatory: true,
	},
	portal_node_type: {
		id: 'portal_node_type',
		value: '',
		name: 'Node type',
		mandatory: true,
	},
	region: {
		id: 'region',
		value: '',
		name: 'Region',
		mandatory: true,
		description: 'The region to which RAD site belongs to.',
		type: 'select',
		hintText: 'Region in which the site to be exist. Choose from drop down.',
	},
	mimic_fc_for_fclm_setup: {
		id: 'mimic_fc_for_fclm_setup',
		value: '',
		name: 'Mimic node for the FCLM setup',
		mandatory: true,
		description: 'The jobIds from this mimic FC will be used to create the new RAD node.',
		type: 'text',
		hintText: 'It should be a existing RAD site name Eg: RAD1',
		regEx: /^[A-Z\d]{4}$/,
	},
	physical_address_name: {
		value: '',
		name: 'Name',
		mandatory: true,
		description: 'Address Name.',
		type: 'text',
	},
	physical_country: {
		value: '',
		name: 'Physical Country',
		mandatory: true,
		description: 'Country',
		type: 'select',
	},
	physical_address_pincode: {
		value: '',
		name: 'Zip/Pincode',
		mandatory: true,
		description: 'Zip/Pincode',
		type: 'text',
	},
	time_zone: {
		value: '',
		name: 'Timezone',
		mandatory: true,
		type: 'select',
	},
	physical_address_city: {
		value: '',
		name: 'City',
		mandatory: true,
		type: 'text',
	},
	physical_address_state: {
		value: '',
		name: 'State',
		mandatory: true,
		type: 'text',
	},
	physical_address_county: {
		value: '',
		name: 'County',
		mandatory: false,
		type: 'text',
	},
	physical_address_line1: {
		value: '',
		name: 'Address line 1',
		mandatory: true,
		type: 'text',
	},
	physical_address_line2: {
		value: '',
		name: 'Address line 2',
		mandatory: false,
		type: 'text',
	},
	physical_address_line3: {
		value: '',
		name: 'Address line 3',
		mandatory: false,
		type: 'text',
	},
};

export const RAD_NODE_TYPE = 'rad';
export const RAD_WORKFLOW_TYPE = 'RAD_WORKFLOW';
export const RAD_ENTITY_DRAFT_STATE = 'DRAFT';
export const RAD_ENTITY_SUBMITTED_STATE = 'READY';
